module.exports = __webpack_public_path__ + "img/nrslogovectorallwhitestacked@2x.6497e6a6.png";